import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const SpreadValue = ({ symbolId }) => {
    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    const [spread, setspread] = useState(0)
    const calculateSpread = (spreadType, spreadValue, ask, bid, digits, id = null) => {
        const power = Math.pow(10, digits || 0);
        const diff = (ask * power) - (bid * power);
        // if (id == 4) {
        //     console.log(ask, bid, diff)
        // }
        return Math.round(Number(diff));
    };
    useEffect(() => {
        const symbolParams = allSymbolParams?.[symbolId] || {};
        const spreadType = symbolParams?.spreadType;
        const spreadValue = symbolParams?.spreadValue;
        setspread(calculateSpread(spreadType, spreadValue, symbol?.ask, symbol?.bid, symbol?.digits, symbol?.id))
    }, [symbol])

    return (
        <div>{isNaN(spread) ? '00' : spread}</div>
    )
}

export default SpreadValue